import { setLangLocale } from '@/libs/functions/lang'
import { useEffect, useState } from 'react'

export default function Index() {
  useEffect(() => {
    console.log(!!window.__POWERED_BY_QIANKUN__) // 判断是否是 Qiankun 子应用);
  }, [])

  return (
    <div style={{ fontSize: 40 }}>
      <div>首页</div>
    </div>
  )
}
